export default "__VITE_ASSET__CmGnuvr9__"